import {useState} from 'react';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/tasks/weekly/online';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination, Autoplay} from 'swiper/modules'
import Diamond from '../diamond';
import Icons from '../icons';

export default () => {
    const {task} = useSelector(Selector),
          [currentSlide, setCurrentSlide] = useState(task ? task.progress.findIndex(x => x.current) : 0)

    if(!task)
        return <></>;

    return (
        <div className="task">
            <div className="task-reward">
                <div className="reward-block">
                    <Diamond />
                    {task.reward}
                </div>
            </div>
            <div className="slide">
                <Swiper
                    modules={[Pagination]}
                    loop={true}
                    slidesPerGroup={1}
                    slidesPerView={1}
                    onInit={(swiper) => {
                        swiper.slideTo(currentSlide);
                    }}
                    onSlideChangeTransitionStart={(swiper) => {
                        console.log(swiper.realIndex);
                        setCurrentSlide(swiper.realIndex);
                    }}>
                    {task.progress.map((day, key) => {
                        return (
                            <SwiperSlide>
                                <div className="task-content" key={key}>
                                    <div className="task-top">
                                        <div className="icon">
                                            {day.className === "success" ? <Icons.Success /> : <></>}
                                            {day.className === "pending" ? <Icons.Pending /> : <></>}
                                            {day.className === "warning" ? <Icons.Warning /> : <></>}
                                        </div>
                                        <div className="task-name">
                                            <span>{day.day}</span>
                                            Daily Login
                                        </div>
                                    </div>
                                    <div className="descriptions">
                                        Visit every day of week and claim shining diamonds.
                                    </div>
                                </div>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
            <div className="task-bottom">
                <div className="pagination">
                    {task.progress.map((day, key) => {
                        return (
                            <div className={`pagination-page ${day.className} ${key === currentSlide ? 'active' : ''}`} key={key}>
                                {day.className === 'success' ? <Icons.SuccessSmall /> : <></>}
                                {day.className === 'pending' ? <Icons.PendingSmall /> : <></>}
                                {day.className === 'warning' ? <Icons.WarningSmall /> : <></>}
                            </div>
                        )
                    })}
                </div>
                {/* <div className="button">Deposit</div> */}
            </div>

            {
                task.progress[0].deposits < 20
                ? (
                    <div className="task-require">
                        <div className="task-require-label">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M5.25 10.0546V8C5.25 4.27208 8.27208 1.25 12 1.25C15.7279 1.25 18.75 4.27208 18.75 8V10.0546C19.8648 10.1379 20.5907 10.348 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.40931 10.348 4.13525 10.1379 5.25 10.0546ZM6.75 8C6.75 5.10051 9.10051 2.75 12 2.75C14.8995 2.75 17.25 5.10051 17.25 8V10.0036C16.867 10 16.4515 10 16 10H8C7.54849 10 7.13301 10 6.75 10.0036V8ZM14 16C14 17.1046 13.1046 18 12 18C10.8954 18 10 17.1046 10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16Z" fill="currentColor"/>
                            </svg>

                            Weekly deposits requirement
                        </div>

                        <div className="task-require-value">
                            <span>${parseFloat(task.progress[0].deposits.toFixed(2))}</span> / $20
                        </div>
                    </div>
                )
                : <></>
            }
        </div>
    )
}